import { initialState, ScreenView, TicketMessageDTO, WebChatDTO } from '../../models/chat.models';

/**
 * This is a reducer, a pure function with (state, action) => state signature.
 * It describes how an action transforms the state into the next state.
 *
 * The shape of the state is up to you: it can be a primitive, an array, an object,
 * or even an Immutable.js data structure. The only important part is that you should
 * not mutate the state object, but return a new object if the state changes.
 *
 * In this example, we use a `switch` statement and strings, but you can use a helper that
 * follows a different convention (such as function maps) if it makes sense for your
 * project.
 */

export function rootReducer(state = initialState, action) {
  console.log('Action dispatched:', action);
  switch (action.type) {
    case 'SET_WEB_CHAT':
      return {
        ...state,
        webChatDto: action.payload
      };
    case 'SET_WEB_CHAT_MESSAGES':
      return {
        ...state,
        messages: action.payload
      };
    case 'SHOW_WELCOME_VIEW':
      return {
        ...state,
        screenView: ScreenView.Welcome
      };
    case 'SHOW_CHAT_VIEW':
      return {
        ...state,
        screenView: ScreenView.Chat
      };
    case 'SHOW_VOICE_CHAT_VIEW':
      return {
        ...state,
        screenView: ScreenView.VoiceChat
      };
    case 'SET_CHAT_OPENED':
      return {
        ...state,
        chatOpened: action.payload
      };
    case 'SET_CHAT_OPENED_FORCE':
      return {
        ...state,
        webChatDto: {
          ...state.webChatDto,
          ForceOpen: action.payload
        }
      };
    case 'SHOW_WELCOME_MESSAGE':
      return {
        ...state,
        welcomeMessage: action.payload
      };
    case 'SET_SUBSCRIBE_CHAT':
      return {
        ...state,
        subscribedChat: action.payload
      };
    case 'SET_MESSAGE':
      return {
        ...state,
        message: action.payload
      };
    case 'SET_WEBCHAT_HEIGHT':
      return {
        ...state,
        webchatHeight: action.payload
      };
    case 'SET_MESSAGE_HEIGHT':
      return {
        ...state,
        messageHeight: action.payload
      };
    case 'ADD_MESSAGE_TO_LIST':
      let message: TicketMessageDTO = action.payload;
      let newArray = state.messages ? state.messages.slice() : [];
      if (!newArray.some(m => m.Id == message.Id)) {
        newArray.push(message);
      }
      return {
        ...state,
        messages: newArray
      };
    case 'SET_TICKET':
      return {
        ...state,
        webChatDto: {
          ...state.webChatDto,
          Ticket: action.payload
        }
      };
    case 'SET_THINKING':
      return {
        ...state,
        isThinking: action.payload
      };
    default:
      return state
  }
}